import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppNavigate } from "../../contexts/navigationContext";
import styles from './css/navigator.module.css';
import { IoMdExit } from "react-icons/io";
import { MdHistory, MdOutlineStorefront, MdSpaceDashboard, MdUpload } from "react-icons/md";
import { FaUsers, FaUserPlus, FaStore, FaHandshake } from "react-icons/fa";
import { FaRectangleAd } from "react-icons/fa6";
import { FiMenu, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { MdOutlineFeedback } from "react-icons/md";
import { SiIfood } from "react-icons/si";
import { useAuth } from '../../hooks/useAuth';
import { user } from '../../classes/user';
import useWindowSize from "../../hooks/useWindowSize";
import { IoIosCloseCircle } from "react-icons/io";
import IbptImportModal from "../ibpt-import-modal";
import CclasstribImportModal from "../cclasstrib-import-modal";
import {DiagramFlowVertical} from "lucide-react";

const MENU_ITEMS = [
    {
        category: 'Geral',
        items: [
            { path: '/home', text: 'Home', icon: MdSpaceDashboard, size: 22 },
            { path: '/clients', text: 'Clientes', icon: FaStore, size: 20 },
            { path: '/open-companies', text: 'Abertos agora', icon: DiagramFlowVertical, size: 20 },
            { path: '/users', text: 'Usuários', icon: FaUsers, size: 20 },
            { path: '/leads', text: 'Leads', icon: FaRectangleAd , size: 20 },
            { path: '/commissioned', text: 'Comissionados', icon: FaHandshake, size: 20, masterOnly: true },
            { path: '/logs', text: 'Logs', icon: MdHistory, size: 20 },
        ],
    },
    {
        category: 'Integrações',
        items: [
            { path: '/reviews', text: 'Avaliações', icon: MdOutlineFeedback, size: 20 },
            { path: '/ifood-requests', text: 'iFood', icon: SiIfood, size: 20 },
        ],
    },
    {
        category: 'Conta',
        items: [
            { path: '/register-user', text: 'Novo usuário', icon: FaUserPlus, size: 20, masterOnly: true },
        ],
    },
    {
        category: 'Importação',
        items: [
            { action: 'ibpt-import', text: 'Importar IBPT', icon: MdUpload, size: 20, masterOnly: true },
            { action: 'cclasstrib-import', text: 'Importar CST/cClassTrib', icon: MdUpload, size: 20, masterOnly: true },
        ],
    },
];


export default function Navigator(){
    const width = useWindowSize();
    const navigate = useAppNavigate();
    const location = useLocation();
    const { logout } = useAuth();
    const [open, setOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(true);
    const [ibptModalOpen, setIbptModalOpen] = useState(false);
    const [cclasstribModalOpen, setCclasstribModalOpen] = useState(false);
    const currentPath = location.pathname;


    useEffect(() => {
        if(width > 768){
            setOpen(false);
        }
    }, [width]);


    const handleNavigate = (path) => {
        navigate(path);
        setOpen(false);
    };


    // MOBILE: botão hambúrguer
    if(!open && width <= 768){
        return (
            <>
                <button className={styles.mobileMenuButton} onClick={() => setOpen(true)}>
                    <FiMenu size={26} color="#fff" />
                </button>
                <IbptImportModal isOpen={ibptModalOpen} onClose={() => setIbptModalOpen(false)} />
                <CclasstribImportModal isOpen={cclasstribModalOpen} onClose={() => setCclasstribModalOpen(false)} />
            </>
        )
    }


    return (
        <>
        <IbptImportModal isOpen={ibptModalOpen} onClose={() => setIbptModalOpen(false)} />
        <CclasstribImportModal isOpen={cclasstribModalOpen} onClose={() => setCclasstribModalOpen(false)} />
            
        <div id={styles.component} className={!isExpanded ? styles.collapsed : ''}>

            {/* Overlay mobile */}
            {open && <div className={styles.overlay} onClick={() => setOpen(false)} />}

            {/* CONTAINER DO MENU */}
            <div id={styles.container} className={`${open ? styles.openMenu : ''} ${!isExpanded ? styles.containerCollapsed : ''}`}> 

                {/* HEADER */}
                <div className={styles.containerHeader}>
                    {isExpanded ? (
                        <div className={styles.headerLogoArea}>
                            <img src='images/Favicon.png' className={styles.headerFavicon} alt="Logo"/>
                            <h2 className={styles.containerHeaderTitle}>Admin</h2>
                        </div>
                    ) : (
                        <div className={styles.headerLogoArea} style={{marginLeft: 'auto', marginRight: 'auto'}}>
                            <img src='images/Favicon.png' className={styles.headerFaviconSmall} alt="Logo"/>
                        </div>
                    )}

                    {width <= 768 && (
                        <IoIosCloseCircle size={20} color='var(--color-primary-background)' onClick={() => setOpen(false)} style={{cursor: 'pointer'}} />
                    )}
                </div>


                {/* SCROLL AREA COM ITENS DO MENU */}
                <div className={styles.scrollNavArea}>
                    {MENU_ITEMS.map((group) => {
                        const isFirst = MENU_ITEMS[0].category === group.category;

                        const filteredItems = group.items.filter((item) => {
                            if (item.masterOnly && !user.master) return false;
                            return true;
                        });

                        if (filteredItems.length === 0) return null;

                        return (
                            <div key={group.category} className={isExpanded ? styles.categoryContainer : null} style={{marginTop: isFirst ? '10px' : '22px'}}>
                                {isExpanded && (
                                    <span className={styles.categoryTitle}>{group.category}</span>
                                )}

                                {filteredItems.map((item) => {
                                    const isActive = item.path ? currentPath === item.path : false;
                                    const Icon = item.icon;

                                    return (
                                        <button
                                            key={item.path || item.action}
                                            className={`${styles.buttonContainer} ${isActive ? styles.buttonActive : ''} ${!isExpanded ? styles.buttonCollapsed : ''}`}
                                            onClick={() => {
                                                if (item.action === 'ibpt-import') {
                                                    setIbptModalOpen(true);
                                                    setOpen(false);
                                                } else if (item.action === 'cclasstrib-import') {
                                                    setCclasstribModalOpen(true);
                                                    setOpen(false);
                                                } else {
                                                    handleNavigate(item.path);
                                                }
                                            }}
                                        >
                                            {isExpanded && (
                                                <div className={`${styles.activeIndicator} ${isActive ? styles.activeIndicatorVisible : ''}`} />
                                            )}

                                            <Icon 
                                                size={item.size || 20} 
                                                color={
                                                    isActive ? 
                                                        isExpanded ? 
                                                            'var(--color-primary-background)' 
                                                            : '#fff'
                                                    : '#5e5e5e'
                                                } 
                                            />

                                            {isExpanded && (
                                                <span className={styles.buttonText} style={{ color: isActive ? '#000' : '#5e5e5e' }}>
                                                    {item.text}
                                                </span>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        );
                    })}


                    {/* BOTÃO DE SAIR */}
                    <div className={styles.categoryContainer}>
                        {isExpanded && (
                            <span className={styles.categoryTitle}>Sessão</span>
                        )}

                        <button
                            className={`${styles.buttonContainer} ${styles.exitButton} ${!isExpanded ? styles.buttonCollapsed : ''}`}
                            onClick={() => logout()}
                        >
                            {isExpanded && <div className={styles.activeIndicator} />}
                            <IoMdExit size={22} color="#5e5e5e" />
                            {isExpanded && (
                                <span className={styles.buttonText} style={{ color: '#5e5e5e' }}>Sair</span>
                            )}
                        </button>
                    </div>
                </div>


                {/* BOTÃO DE EXPANDIR / RECOLHER */}
                {width > 768 && (
                    <button className={styles.btnExpand} onClick={() => setIsExpanded(!isExpanded)}>
                        {isExpanded ? <FiChevronLeft size={17} color="#fff" /> : <FiChevronRight size={17} color="#fff" />}
                    </button>
                )}
            </div>
        </div>
        </>
    )
}
